import { CoverageSchema } from '@/services/types/coverage-types';

// Helper function to get the primary policy identifier for display
export const getPrimaryPolicyIdentifier = (
  coverage: CoverageSchema,
): string | null => {
  if (
    !coverage.policy_identifiers ||
    coverage.policy_identifiers.length === 0
  ) {
    return null;
  }

  // Prefer policy number, then member ID, then first available
  const policyNumber = coverage.policy_identifiers.find(
    (id) => id.identifier_type === 'POLICY_NUMBER',
  );
  if (policyNumber) return policyNumber.identifier_value;

  const memberId = coverage.policy_identifiers.find(
    (id) => id.identifier_type === 'MEMBER_ID',
  );
  if (memberId) return memberId.identifier_value;

  return coverage.policy_identifiers[0].identifier_value;
};

// Format limit values for display - shared from CoverageLimitsSection
export const formatLimitValue = (value: string | number): string => {
  // Convert to string and preserve complex formatting like "/$500 deductible"
  const stringValue = String(value);
  // Only remove redundant leading $ if it's a simple number, preserve complex strings
  if (/^\$[\d,]+$/.test(stringValue)) {
    return stringValue.replace(/^\$/, '');
  }
  return stringValue;
};

// Check if a limit key is high priority - shared from CoverageLimitsSection
export const isHighPriorityLimit = (key: string): boolean => {
  const lowerKey = key.toLowerCase();
  return (
    lowerKey.includes('deductible') ||
    lowerKey.includes('per occurrence') ||
    lowerKey.includes('per incident') ||
    lowerKey.includes('aggregate') ||
    lowerKey.includes('liability')
  );
};
